import React, { Component } from "react";
import "antd/dist/antd.css";
import { FilePdfOutlined } from "@ant-design/icons";
import {
  Checkbox,
  Row,
  Col,
  Spin,
  Button,
  Card,
  Tabs,
  Form,
  message,
  notification,
} from "antd";
import { Link } from "react-router-dom";
import AppConfigs from "../../Config/AppConfig";
import { Storage } from "aws-amplify";
import { list, add } from "../../api/Apis";
import CustomerRegProductList from "../../Components/Products/CustomerRegProductList";
import "./stones.css";

const { TabPane } = Tabs;
class Stone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedValues: { categories: [], subCategories: [], sizes: [] },
      productsData: [],
      displayProducts: [],
      dataLoadingStatus: true,
      checkAll: false,
      totalProducts: [],
      category: [],
      categoriesList: [],
      subCategoriesList: [],
      isToggleOn: true,
      products: [],
      tabKey: "",
      check: false,
      rowSelection: [],
      selectedProducts: [],
      selectedRowKeys: [],
      userDetails: JSON.parse(localStorage.getItem("userDetails")),
      orgDetails: JSON.parse(localStorage.getItem("orgDetails")),
      palletCount: 0,
      supetSackCount: 0,
      count: 0,
    };
  }
  increment = (product) => {
    let add = 0;
    let selectedProduct = this.state.displayProducts.filter(
      (item) => item.id === product.id
    );
    if (product.category === "37638d60-2b19-11eb-b05c-a3fa7baaf1b5") {
      add = 1;
      // if (this.state.count + 1 > 24) {
      //   message.error("Maximum 24 tons allow");
      // } else {
      selectedProduct[0].count = selectedProduct[0].count + 1;
      const target = this.state.displayProducts.find(
        (obj) => obj.id === product.id
      );
      Object.assign(target, selectedProduct);
      this.setState({
        supetSackCount: this.state.supetSackCount + 1,
      });
      // }
    } else {
      add = 1.5;
      // if (this.state.count+1.5 > 24) {
      //   message.error("Maximum 24 tons allow");
      // } else {
      selectedProduct[0].count = selectedProduct[0].count + 1;
      const target = this.state.displayProducts.find(
        (obj) => obj.id === product.id
      );
      Object.assign(target, selectedProduct);
      this.setState({
        palletCount: this.state.palletCount + 1.5,
      });
    }
    // }
    this.setState({
      count: this.state.count + add,
    });
  };

  decrement = (product) => {
    let sub = 0;
    let selectedProduct = this.state.displayProducts.filter(
      (item) => item.id === product.id
    );
    if (product.category === "37638d60-2b19-11eb-b05c-a3fa7baaf1b5") {
      sub = 1;
      selectedProduct[0].count = selectedProduct[0].count - 1;
      const target = this.state.displayProducts.find(
        (obj) => obj.id === product.id
      );
      Object.assign(target, selectedProduct);
      this.setState({
        supetSackCount: this.state.supetSackCount - 1,
      });
    } else {
      sub = 1.5;
      selectedProduct[0].count = selectedProduct[0].count - 1;
      const target = this.state.displayProducts.find(
        (obj) => obj.id === product.id
      );
      Object.assign(target, selectedProduct);
      this.setState({
        palletCount: this.state.palletCount - 1.5,
      });
    }
    this.setState({
      count: this.state.count - sub,
    });
  };

  componentDidMount() {
    let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    if (orgDetails.userProfile !== "SCU") {
      if (orgDetails.approvalStatus === "D") {
        this.props.history.push("/carrier_app/review");
      } else if (!orgDetails["customerDocuments"]) {
        this.props.history.push("/app/customerdocumentation");
      } else if (!orgDetails["customerLocations"]) {
        this.props.history.push("/app/customerlocations");
      } else if (!orgDetails["productsSelected"]) {
        this.props.history.push("/app/customerProducts");
      } else if (
        (this.state.userDetails["userProfile"] === "SCU" ||
          this.state.userDetails["userProfile"] === "CU") &&
        !orgDetails["isActive"]
      ) {
        this.props.history.push("/carrier_app/review");
      } else if (!orgDetails["isActive"]) {
        this.props.history.push("/carrier_app/review");
      }
    }
    this.getCategoriesData();
    if (this.state.userDetails["userProfile"] === "SCU") {
      if (!this.state.userDetails["recordStatus"]) {
        this.props.history.push("/carrier_app/review");
      } else {
        this.getProducts(this.state.userDetails.orgId);
      }
    } else {
      this.getProducts(orgDetails.id);
    }
  }

  getCategoriesData = () => {
    let query = {
      dataType: "category",
      recordStatus: true,
    };
    list(AppConfigs["entityNames"]["masterData"], query).then((result) => {
      if (result.success) {
        this.setState({
          categoriesList: result.data.map((cat) => {
            return { label: cat.name, value: cat.id };
          }),
        });
        query = {
          dataType: "subCategory",
          recordStatus: true,
        };
        list(AppConfigs["entityNames"]["masterData"], query).then((subCat) => {
          if (subCat.success) {
            let subCategories = [];
            subCat.data.map((sub) => {
              let checkExist = subCategories.filter((s) => s.name === sub.name);
              if (checkExist.length === 0) {
                subCategories.push(sub);
              }
              return sub;
            });
            this.setState({
              subCategoriesList: subCategories
                .sort((a, b) => (a.name > b.name ? 1 : -1))
                .map((cat) => {
                  return { label: cat.name, value: cat.id };
                }),
            });
          } else {
            console.log(subCat.errors);
          }
        });
      } else {
        console.log(result.errors);
        this.setState({
          dataLoading: false,
        });
      }
    });
  };

  getProducts = async (customerId) => {
    let itemType = this.props.location.state;
    list(AppConfigs["getCustomerProducts"] + "/" + customerId, {}).then(
      (result) => {
        if (result.success) {
          let productsData = result.data;
          this.setState({
            products: productsData,
          });
          this.sortProducts(itemType ? itemType : "Bulk Gravel");
        } else {
          console.log(result.errors);
          this.setState({
            dataLoadingStatus: false,
          });
        }
      }
    );
  };

  sortProducts = async (key) => {
    let productsData = this.state.products;
    let keyData = key === "Other products" ? "Bulk Gravel" : key;
    let productLen = 0;
    let sizeId = 0;
    let displayProducts = [];
    let displayInActive = [];
    if (!productsData[key]) {
      this.setState({
        dataLoadingStatus: false,
      });
    }
    if (keyData === "Palletized Stone" && productsData["SuperSack"]) {
      productsData[keyData] = [
        ...productsData[keyData],
        ...productsData["SuperSack"],
      ];
    }
    productsData[keyData] &&
      productsData[keyData].map(async (product, index) => {
        product["image"] = await Storage.get(product["images"]?.[0]);
        await [
          ...new Map(
            product.sizes.map((item) => [item["size"], item])
          ).values(),
        ].map(async (size) => {
          let imagepath = "";
          if (size["sizeUploadImg"] !== null && key === "Bulk Gravel") {
            imagepath = await Storage.get(
              // product.productCode.replace(/\s+/g, "") +
              //   "_" +
              size["sizeUploadImg"]
            );
          } else {
            imagepath = product["image"];
          }
          var x = size.size
            ? size.size.replace(/[^-/0-9]/g, "").split("-")
            : "";
          var sizes = [];
          if (x.length > 1) {
            let fValue =
              x[0].split("/").length > 1
                ? parseInt(x[0].split("/")[0]) / parseInt(x[0].split("/")[1])
                : parseInt(x[0]);
            let sValue =
              x[1].split("/").length > 1
                ? parseInt(x[1].split("/")[0]) / parseInt(x[1].split("/")[1])
                : parseInt(x[1]);
            sizes.push(fValue);
            sizes.push(sValue);
          } else {
            let ar = x[0]?.toString().split("/");
            let fValue =
              ar?.length > 1
                ? parseInt(ar[0]) / parseInt(ar[1])
                : parseInt(x[0]);
            sizes.push(fValue);
          }
          sizeId += 1;
          const duplicate = displayProducts.find(
            (item) =>
              item.productId === product.id && item.size.size === size.size
          );
          if (product.isActive && !duplicate) {
            displayProducts.push({
              id: sizeId,
              productId: product.id,
              productName: product.productName,
              img: imagepath,
              size: size,
              category: product.productCategory,
              subCategory: product.productSubCategory,
              sizes: sizes,
              count: 0,
            });
          } else if (!product.isActive && !duplicate) {
            displayInActive.push({
              id: sizeId,
              productId: product.id,
              productName: product.productName,
              img: imagepath,
              size: size,
              category: product.productCategory,
              subCategory: product.productSubCategory,
              sizes: sizes,
              image: imagepath,
              productCode: product.productCode,
              description: product.description,
            });
          }
          this.setState({
            displayProducts:
              key === "Other products" ? displayInActive : displayProducts,
            totalProducts: displayProducts,
            tabKey:
              key === "Bulk Gravel"
                ? "bulk"
                : key === "Palletized Stone"
                ? "pallet"
                : "Other products",
            dataLoadingStatus: false,
          });
        });
        if (product.sizes.length === 0) {
          if (product.isActive) {
            displayProducts.push({
              id: sizeId,
              productId: product.id,
              productName: product.productName,
              img: product["image"],
              // size: size.size,
              category: product.productCategory,
              subCategory: product.productSubCategory,
              // sizes: sizes,
              count: 0,
            });
          } else if (!product.isActive) {
            displayInActive.push({
              id: sizeId,
              productId: product.id,
              productName: product.productName,
              img: product["image"],
              // size: size.size,
              category: product.productCategory,
              subCategory: product.productSubCategory,
              // sizes: sizes,
              image: product["image"],
              productCode: product.productCode,
              description: product.description,
            });
          }
          this.setState({
            displayProducts:
              key === "Other products" ? displayInActive : displayProducts,
            totalProducts: displayProducts,
            tabKey:
              key === "Bulk Gravel"
                ? "bulk"
                : key === "Palletized Stone"
                ? "pallet"
                : "Other products",
            dataLoadingStatus: false,
          });
        }
        productLen += 1;
        if (productsData[keyData].length === productLen) {
          this.setState({
            productsData: productsData[keyData],
            displayProducts: displayProducts,
          });
        }
      });
    if (productsData.length === 0) {
      this.setState({
        dataLoadingStatus: false,
      });
    }
  };

  sizeFilter = (checkedValues) => {
    let globalCheckedValues = this.state.checkedValues;
    globalCheckedValues["sizes"] = checkedValues;
    this.setState({
      checkedValues: globalCheckedValues,
    });
    this.filterProducts();
  };

  onChange = (checkedValues) => {
    let globalCheckedValues = this.state.checkedValues;
    globalCheckedValues["categories"] = checkedValues;
    this.setState({
      checkedValues: globalCheckedValues,
    });
    this.filterProducts();
  };

  handletabChange = (key) => {
    this.sortProducts(key);
  };

  subCategoryOnChange = (checkedValues) => {
    let globalCheckedValues = this.state.checkedValues;
    globalCheckedValues["subCategories"] = checkedValues;
    this.setState({
      checkedValues: globalCheckedValues,
    });
    this.filterProducts();
  };

  filterProducts = async () => {
    let totalProducts = this.state.totalProducts;
    if (
      this.state.checkedValues["sizes"].length > 0 ||
      this.state.checkedValues["categories"].length > 0 ||
      this.state.checkedValues["subCategories"].length > 0
    ) {
      // Filter categories
      if (this.state.checkedValues["categories"].length > 0) {
        const newFilterData = totalProducts.filter((product) => {
          const itemData = `${product.category}`;
          return this.state.checkedValues["categories"].indexOf(itemData) > -1;
        });
        totalProducts = newFilterData;
      }

      // Filter sub categories
      if (this.state.checkedValues["subCategories"].length > 0) {
        const newSubCategoriesFilterData = totalProducts.filter((product) => {
          const subCategory = `${product.subCategory}`;
          return (
            this.state.checkedValues["subCategories"].indexOf(subCategory) > -1
          );
        });
        totalProducts = newSubCategoriesFilterData;
      }
      // Filter sizez
      if (this.state.checkedValues["sizes"].length > 0) {
        let newSizezFilterData = [];
        totalProducts.filter((product) => {
          let count = 0;
          while (count < this.state.checkedValues["sizes"].length) {
            let sizeArr = this.state.checkedValues["sizes"][count].split(",");
            if (
              sizeArr[0] < product?.sizes?.[0] &&
              sizeArr[1] > product?.sizes?.[0]
            ) {
              newSizezFilterData.push(product);
              break;
            }
            count += 1;
          }
          return newSizezFilterData;
        });
        totalProducts = newSizezFilterData;
      }
    }
    this.setState({
      displayProducts: totalProducts,
    });
  };
  imageSizeChange = () => {
    this.setState({
      imageSize: true,
    });
  };

  onSelectChange = (data) => {
    let selectedProducts = this.state.selectedProducts;
    if (data) {
      selectedProducts.splice(selectedProducts.indexOf(data), 1);
      selectedProducts.push(data);
    }
    this.setState({ selectedRowKeys: data });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    if (this.state.selectedRowKeys.length === 0) {
      message.error("Please select products!");
      return;
    }
    this.setState({
      loading: true,
    });
    let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    let allProducts = [...this.state.selectedProducts[0]];
    let allProductsData = [];
    console.log(allProducts);
    this.state.displayProducts.filter((id) =>
      allProducts.filter(
        (selectedId) =>
          selectedId === id.id &&
          allProductsData.push({
            productCode: id.productCode,
            productName: id.productName,
          })
      )
    );
    let data = {
      entityData: {
        customerProducts: allProductsData,
        customerName: userDetails["firstName"] + " " + userDetails["lastName"],
        companyName: orgDetails["companyName"],
        orgId: orgDetails.orgId,
        customerId: orgDetails["id"],
      },
    };

    add(AppConfigs["customerRequestProducts"], data).then((result) => {
      if (result.success) {
        console.log(result);
        message.success("Products added successfully!");
        this.setState({
          loading: false,
          selectedRowKeys: [],
        });
      } else {
        console.log(result.errors);
        this.setState({
          loading: false,
        });
      }
    });
  };
  addToCart = () => {
    if (parseInt(this.state.count + 0.5) === 24) {
      this.setState({
        dataLoadingStatus: true,
      });
      const selectedProducts = this.state.displayProducts.filter(
        (item) => item.count !== 0
      );
      // eslint-disable-next-line array-callback-return
      selectedProducts.map((product) => {
        let data = {
          entityData: {
            productId: product.productId,
            size: product.size.size,
            productLinkId: product.productId,
            measurementType: "Pallet",
            deliveryTruck: "CustomerPickup",
            quantity: product.count,
            customerId: this.state.orgDetails["id"],
            orgId: this.state.orgDetails["orgId"],
            itemType:
              product.category === "37638d60-2b19-11eb-b05c-a3fa7baaf1b5"
                ? "SuperSack"
                : "Pallet",
            totalAmt:
              (product?.size?.price ? product?.size?.price : 1) * product.count,
          },
        };
        let existingCartData = JSON.parse(localStorage.getItem("cartData"));
        const stoneWeight = 1.5,
          stoneData = product?.size;
        let total_weight = 0;
        if (existingCartData != null) {
          existingCartData.map((d) => (total_weight = total_weight + d.weight));
        }
        let check_total_weight;
        let ton = 0;
        if (existingCartData != null) {
          existingCartData.map((d) => (ton = ton + d.ton));
        }
        let totalQuantity =
          ton + stoneWeight ? stoneWeight : stoneData[0]["ton"];
        if (totalQuantity > 24) {
          notification["error"]({
            message:
              "You can only order up to 24 pallets per truck in a single order. If you wish to order more than 24 pallets, please create a new order with the additional pallets. Thank you.",
          });
          this.setState({
            dataLoadingStatus: false,
          });
          // eslint-disable-next-line array-callback-return
          return;
        }
        let numOfTons;
        let checkProduct =
          existingCartData !== null &&
          existingCartData.filter(
            (c) =>
              c.productId === product.productId &&
              c.measurementType === "pallet" &&
              stoneData[0]["size"] === c.size
          );
        if (checkProduct.length > 0) {
          data["entityData"]["quantity"] =
            parseInt(checkProduct[0]["quantity"]) + parseInt(product.count);
          data["entityData"]["id"] = checkProduct[0]["id"];
          let totalTon =
            parseFloat(data["entityData"]["ton"]) * parseInt(product.count);
          numOfTons =
            parseFloat(checkProduct[0]["weight"]) + parseFloat(totalTon);
        } else {
          let totalTon = data["entityData"]?.["ton"];
          numOfTons = parseFloat(totalTon) * data["entityData"]["quantity"];
        }
        check_total_weight = total_weight + product.count;
        data["entityData"]["wieght"] = numOfTons;

        data["entityData"]["ton"] =
          stoneWeight !== ""
            ? stoneWeight
            : stoneData.length > 0 && stoneData[0]?.ton;
        if (data["entityData"]["wieght"] > 24 || check_total_weight > 24) {
          notification["error"]({
            message:
              "An order can have a max of 24 tons. Please remove some items from the cart to proceed.",
          });
          this.setState({
            dataLoadingStatus: false,
            addToCartMilfordLoading: false,
          });
          // eslint-disable-next-line array-callback-return
          return;
        }
        add(AppConfigs["addItemToCart"], data).then((result) => {
          if (result.success) {
            let cartData = result.data.data;
            cartData &&
              cartData.map(async (item, index) => {
                item["originalPath"] = item["image"];
                item["image"] = await Storage.get(item["image"]);
                if (cartData.length === index + 1) {
                  this.props.context &&
                    this.props.context.setCartData(cartData);
                  localStorage.setItem("cartData", JSON.stringify(cartData));
                  message.success("Product added to cart");
                }
              });
          } else {
            message.error(`Product not added to cart`);
            console.log(result.errors);
          }
          this.setState({
            dataLoadingStatus: false,
          });
          window.location.reload();
        });
      });
    }
  };
  handleClick = () => {
    this.setState((prevState) => ({
      isToggleOn: !prevState.isToggleOn,
    }));
  };

  render() {
    const { selectedRowKeys } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    const Sizeoptions = [
      { label: ' <1" ', value: "0,1" },
      { label: '1-2"', value: "0.99,1.99" },
      { label: '2-4"', value: "1.99,3.99" },
      { label: '4-8"', value: "3.99,7.99" },
      { label: " >8 ", value: "7.99,100" },
    ];
    return (
      <div>
        <Row className="stonepage">
          <Col span={4}>
            <div className="site-card-border-less-wrapper stonesCard">
              <Card>
                <div className="stones-checkbox">
                  <h3 className="filterheading">SIZE</h3>
                  <Checkbox.Group
                    options={Sizeoptions}
                    defaultValue={["Apple"]}
                    onChange={this.sizeFilter}
                  />
                </div>
              </Card>
            </div>
          </Col>
          <Col xl={20} lg={20} md={20} sm={24} xs={24}>
            <div className="filterdiv">
              <Row>
                <Col span={24}>
                  <Tabs
                    style={{ marginBottom: "1vw" }}
                    className="stones-tab"
                    onChange={this.handletabChange}
                    defaultActiveKey={
                      this.props.location.state
                        ? this.props.location.state
                        : "Bulk Gravel"
                    }
                  >
                    <TabPane tab="Bulk Gravel" key="Bulk Gravel"></TabPane>
                    <TabPane
                      tab="Palletized Stone"
                      key="Palletized Stone"
                    ></TabPane>
                    <TabPane
                      tab="Other products"
                      key="Other products"
                    ></TabPane>
                  </Tabs>
                </Col>

                <Col span={12}>
                  {this.state.tabKey !== "Other products" ? (
                    <h4 className="resultnum">
                      {this.state.displayProducts.length + " results shown"}
                    </h4>
                  ) : (
                    <h4 className="resultnum">
                      {[
                        ...new Map(
                          this.state.displayProducts.map((item) => [
                            item["productCode"],
                            item,
                          ])
                        ).values(),
                      ].length + " results shown"}
                    </h4>
                  )}
                </Col>
                {this.state.tabKey !== "Other products" && (
                  <>
                    <Col span={6}>
                      {/* <Link> */}
                      <FilePdfOutlined className="filepdf" />
                      <h4 className="pdfprice">Review PDF with prices</h4>
                      {/* </Link> */}
                    </Col>
                    <Col span={6}>
                      <div style={{ float: "right", marginRight: "16px" }}>
                        {this.state.tabKey === "pallet" && (
                          <Button
                            type="primary"
                            style={{ marginRight: "16px" }}
                            onClick={() => this.addToCart()}
                          >
                            {parseInt(this.state.count + 0.5) === 24
                              ? "Add to Cart"
                              : "Build a Pallet Order"}
                          </Button>
                        )}
                        {this.state.tabKey !== "pallet" && (
                          <Button type="primary" onClick={this.handleClick}>
                            {this.state.isToggleOn ? "SMALL" : "LARGE"}
                          </Button>
                        )}
                        {this.state.tabKey === "pallet" && (
                          <Button type="primary" className="weightCountButton">
                            {this.state.count}
                          </Button>
                        )}
                      </div>
                    </Col>
                  </>
                )}
              </Row>
              <Col span={24}>
                <div>
                  <Spin spinning={this.state.dataLoadingStatus}>
                    {this.state.tabKey !== "Other products" ? (
                      this.state.tabKey !== "pallet" ? (
                        this.state.displayProducts.map((pdata) => (
                          <Link
                            style={{
                              display:
                                this.state.tabKey === "bulk"
                                  ? "inline-flex"
                                  : "",
                            }}
                            to={
                              "/app/stones/stonedetails/" +
                              pdata.productId +
                              "?size=" +
                              pdata.size.size +
                              "&itemType=" +
                              this.state.tabKey
                            }
                            key={pdata.productId}
                          >
                            {this.state.isToggleOn === false && (
                              <div>
                                <div
                                  className="stones"
                                  style={{
                                    display:
                                      this.state.tabKey === "bulk"
                                        ? "inline-block"
                                        : "none",
                                  }}
                                >
                                  <img
                                    className="stoneimg"
                                    src={pdata.img}
                                    alt="Not Uploaded"
                                    style={{
                                      width: "125px",
                                      height: "125px",
                                      objectFit: "cover",
                                    }}
                                  />
                                  <div style={{ marginTop: "5%" }}>
                                    <p className="stonetextsmall">
                                      {pdata.size.size} {pdata.productName}
                                    </p>
                                  </div>
                                </div>
                                <div
                                  className="stones w-90"
                                  style={{
                                    display:
                                      this.state.tabKey === "bulk"
                                        ? "none"
                                        : "inline-block",
                                  }}
                                >
                                  <img
                                    className="stoneimg removeImg"
                                    src={pdata.img}
                                    alt="Not Uploaded"
                                    style={{
                                      width: "125px",
                                      height: "125px",
                                      objectFit: "cover",
                                    }}
                                  />
                                  <div className="stones-counting stone-jse">
                                    <p
                                      className="stonetextsmall w-500"
                                      style={{ margin: "0" }}
                                    >
                                      {pdata.size.size} {pdata.productName}
                                    </p>
                                    <Row className="stones-counting">
                                      <Col>
                                        <span className="perton">
                                          Quantity:
                                        </span>
                                        {pdata.count === 0 ? (
                                          <Button
                                            className="quantitybtn"
                                            disabled={true}
                                          >
                                            -
                                          </Button>
                                        ) : (
                                          <Button
                                            onClick={() =>
                                              this.decrement(pdata)
                                            }
                                            className="quantitybtn"
                                          >
                                            -
                                          </Button>
                                        )}
                                        <span className="count">
                                          {parseInt(pdata.count)}
                                        </span>
                                        {this.state.count === 24 ? (
                                          <Button
                                            className="quantitybtn"
                                            disabled={true}
                                          >
                                            +
                                          </Button>
                                        ) : (
                                          <Button
                                            onClick={() =>
                                              this.increment(pdata)
                                            }
                                            className="quantitybtn"
                                          >
                                            +
                                          </Button>
                                        )}
                                      </Col>
                                      <Col>
                                        <span className="perton">
                                          {pdata.category ===
                                          "37638d60-2b19-11eb-b05c-a3fa7baaf1b5"
                                            ? pdata.count + " SuperSack"
                                            : parseInt(pdata.count) +
                                              " Pallet(s)"}
                                        </span>
                                      </Col>
                                    </Row>
                                    {/* <p className="stonetextsmall">
                                  Size: {pdata.size}
                                </p> */}
                                  </div>
                                </div>
                              </div>
                            )}
                            {this.state.isToggleOn === true && (
                              <div>
                                <div
                                  className="stones"
                                  style={{
                                    display:
                                      this.state.tabKey === "bulk"
                                        ? "inline-block"
                                        : "none",
                                  }}
                                >
                                  <img
                                    className="stoneimg"
                                    src={pdata.img}
                                    alt="Not Uploaded"
                                    style={{
                                      width: "250px",
                                      height: "250px",
                                      objectFit: "cover",
                                    }}
                                  />
                                  <div style={{ marginTop: "5%" }}>
                                    <p className="stonetextsmall">
                                      {pdata.size.size} {pdata?.productName}
                                    </p>
                                  </div>
                                </div>
                                <div
                                  className="stones w-90"
                                  style={{
                                    display:
                                      this.state.tabKey === "bulk"
                                        ? "none"
                                        : "inline-block",
                                  }}
                                >
                                  <img
                                    className="stoneimg removeImg"
                                    src={pdata.img}
                                    alt="Not Uploaded"
                                    style={{
                                      width: "250px",
                                      height: "250px",
                                      objectFit: "cover",
                                    }}
                                  />
                                  <div className="stones-counting stone-jse">
                                    <p
                                      className="stonetextbig w-500"
                                      style={{ margin: "0" }}
                                    >
                                      {pdata.size.size} {pdata.productName}
                                    </p>
                                    <Row className="stones-counting">
                                      <Col>
                                        <span className="perton">
                                          Quantity:
                                        </span>
                                        {pdata.count === 0 ? (
                                          <Button
                                            className="quantitybtn"
                                            disabled={true}
                                          >
                                            -
                                          </Button>
                                        ) : (
                                          <Button
                                            onClick={() =>
                                              this.decrement(pdata)
                                            }
                                            className="quantitybtn"
                                          >
                                            -
                                          </Button>
                                        )}
                                        <span className="count">
                                          {parseInt(pdata.count)}
                                        </span>
                                        {this.state.count === 24 ? (
                                          <Button
                                            className="quantitybtn"
                                            disabled={true}
                                          >
                                            +
                                          </Button>
                                        ) : (
                                          <Button
                                            onClick={() =>
                                              this.increment(pdata)
                                            }
                                            className="quantitybtn"
                                          >
                                            +
                                          </Button>
                                        )}
                                      </Col>
                                      <Col>
                                        <span className="perton">
                                          {pdata.category ===
                                          "37638d60-2b19-11eb-b05c-a3fa7baaf1b5"
                                            ? pdata.count + " SuperSack"
                                            : parseInt(pdata.count) +
                                              " Pallet(s)"}
                                        </span>
                                      </Col>
                                    </Row>
                                  </div>
                                </div>
                              </div>
                            )}
                          </Link>
                        ))
                      ) : (
                        this.state.displayProducts.map((pdata) => (
                          <div
                            className="stones w-90"
                            style={{
                              display: "inline-block",
                            }}
                          >
                            <div className="stones-counting stone-jse">
                              <p
                                className="stonetextbig w-500"
                                style={{ margin: "0" }}
                              >
                                {pdata.size.size} {pdata.productName}
                              </p>
                              <Row className="stones-counting">
                                <Col>
                                  <span className="perton">Quantity:</span>
                                  {pdata.count === 0 ? (
                                    <Button
                                      className="quantitybtn"
                                      disabled={true}
                                    >
                                      -
                                    </Button>
                                  ) : (
                                    <Button
                                      onClick={() => this.decrement(pdata)}
                                      className="quantitybtn"
                                    >
                                      -
                                    </Button>
                                  )}
                                  <span className="count">
                                    {parseInt(pdata.count)}
                                  </span>
                                  {parseInt(this.state.count + 0.5) === 24 ? (
                                    <Button
                                      className="quantitybtn"
                                      disabled={true}
                                    >
                                      +
                                    </Button>
                                  ) : (
                                    <Button
                                      onClick={() => this.increment(pdata)}
                                      className="quantitybtn"
                                    >
                                      +
                                    </Button>
                                  )}
                                </Col>
                                <Col>
                                  <span className="perton">
                                    {pdata.category ===
                                    "37638d60-2b19-11eb-b05c-a3fa7baaf1b5"
                                      ? pdata.count + " SuperSack"
                                      : parseInt(pdata.count) + " Pallet(s)"}
                                  </span>
                                </Col>
                              </Row>
                            </div>
                          </div>
                        ))
                      )
                    ) : (
                      <Form
                        onSubmit={this.handleSubmit}
                        style={{ background: "#ffff", overflow: "auto" }}
                      >
                        <Row>
                          <Col
                            lg={20}
                            md={20}
                            sm={20}
                            xs={20}
                            style={{ marginTop: "2%", background: "#ffff" }}
                          >
                            <CustomerRegProductList
                              data={[
                                ...new Map(
                                  this.state.displayProducts.map((item) => [
                                    item["productCode"],
                                    item,
                                  ])
                                ).values(),
                              ]}
                              dataLoadingStatus={this.state.dataLoadingStatus}
                              rowSelection={rowSelection}
                              pagination={{ pagination: false }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Form.Item style={{ textAlign: "center" }}>
                            <Button
                              type="primary"
                              htmlType="submit"
                              loading={this.state.loading}
                              className="truckSubmit"
                            >
                              Submit
                            </Button>
                          </Form.Item>
                        </Row>
                      </Form>
                    )}
                  </Spin>
                </div>
              </Col>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
export default Stone;
